import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { SectionHeader } from "@/components/shared/Common";
import { Lock, MessageSquare, FileText, ShieldCheck, ChevronRight } from "lucide-react";

export default function AdminNegotiations() {
  const [rooms, setRooms] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/admin/negotiations");
      setRooms(data || []);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6">
      <SectionHeader eyebrow="Admin oversight" title="Negotiation rooms" subtitle="Every secure client/professional negotiation on the platform. Read-only unless action is required." />
      {busy && <div className="text-white/60 font-manrope text-sm">Loading…</div>}
      {!busy && rooms.length === 0 && (
        <div className="card-flat p-10 text-center text-white/60 font-manrope">No negotiation rooms yet.</div>
      )}
      <div className="grid gap-3">
        {rooms.map(r => (
          <div key={r.id} className="card-flat p-5 border-l-4 border-l-brand" data-testid={`admin-negot-${r.id}`}>
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div className="min-w-0">
                <div className="text-xs uppercase tracking-widest text-brand font-outfit font-bold flex items-center gap-1"><Lock className="w-3.5 h-3.5" /> Room {r.id.slice(0, 8)} · {r.status.replace(/_/g, " ")}</div>
                <div className="font-outfit font-bold text-white truncate">{r.subject}</div>
                <div className="text-sm text-white/60 font-manrope">{r.company_name} ↔ {r.target_name}</div>
                <div className="flex flex-wrap gap-3 text-xs text-white/60 font-manrope mt-2">
                  <span><MessageSquare className="w-3 h-3 inline mr-1" /> {r.messages_count} msgs</span>
                  <span><FileText className="w-3 h-3 inline mr-1" /> Contract v{r.contract_version}{r.contract_locked ? " · locked" : ""}</span>
                  <span><ShieldCheck className="w-3 h-3 inline mr-1" /> {r.signatures_count} signatures</span>
                  <span>Updated {new Date(r.updated_at).toLocaleString()}</span>
                </div>
              </div>
              <Link to={`/negotiations/${r.id}`} className="text-brand font-manrope font-semibold text-sm inline-flex items-center gap-1" data-testid={`admin-negot-open-${r.id}`}>Open room <ChevronRight className="w-4 h-4" /></Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
